import { Apis } from "../../lib/Apis";

export const useBrandHook = () => {
  const addBrand = async (data) => {
    try {
      const response = await Apis.addBrand(data);
      return response;
    } catch (error) {
      return error;
    }
  };

  const getBrands = async (setBrands) => {
    try {
      const response = await Apis.getBrands();
      if (setBrands && response?.data) {
        setBrands(response.data);
      }
      return response;
    } catch (error) {
      return error;
    }
  };

  const updateBrand = async (brandId, data) => {
    try {
      const response = await Apis.updateBrand(brandId, data);
      return response;
    } catch (error) {
      return error;
    }
  };

  const deleteBrand = async (brandId) => {
    try {
      const response = await Apis.deleteBrand(brandId);
      return response;
    } catch (error) {
      return error;
    }
  };

  return {
    addBrand,
    getBrands,
    updateBrand,
    deleteBrand,
  };
};